import { useContext, useEffect } from 'react';

import { Store } from '@src/store';

export const useHandlePressKey = (
  key: number,
  handler: () => void,
  ...otherDeps: any[]
) => {
  const {
    state: {
      stateUser: { selectedProduct },
    },
  } = useContext(Store);
  useEffect(() => {
    const keyDownHandler = (event: KeyboardEvent) => {
      if (event.keyCode === key) {
        event.preventDefault();
        handler();
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [selectedProduct, ...otherDeps]);
};
